<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'650px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @close="$emit('closeDialog')"
    >
      <template #body>
        <h3 class="dialogTitle margin-bottom-10">{{ title }}</h3>
        <div
          class="group__info margin-top-10 margin-bottom-10 padding-bottom-10"
        >
          <div class="ctn">
            <template>
              <el-table
                class="table detailRelatedDocs"
                :data="docVersions"
                style="max-width: 100%; width: 100%;"
                size="mini"
              >

                <el-table-column
                  label="Người tạo"
                  width="135"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.creatorName
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Ngày tạo"
                  width="135"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.createTime
                        | dateFormatter({ dateFormat: "DD/MM/YYYY", nullValue: "-" })
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Version"
                  width="100"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{scope.row.version}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Trạng thái"
                  width="100"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{scope.row.isActive==1?'Kích hoạt':''}}
                  </template>
                </el-table-column>
                <el-table-column align="center" header-align="left" label="Chi tiết" width="110">
                  <template slot-scope="scope">
                    <i
                      class="el-icon-view font-size__large color__green clickable"
                      @click="viewDocVersion(scope.row)"
                    ></i>
                  </template>
                </el-table-column>


              </el-table>
            </template>
            <CreateVersionLanhDaoDialog
              :isOpen="isOpenDialogCreateVersion"
              :docVersionActive="docVersionActive"
              :mode="mode"
              :isConfigLD="isConfigLD"
              v-if="isEnableDialogCreateVersion"
              @closed="isEnableDialogCreateVersion = false"
              @closeDialog="isOpenDialogCreateVersion = false"
              @success="createDocSuccessVersion"
            >
            </CreateVersionLanhDaoDialog>
          </div>

        </div>
      </template>

      <template #footer>
        <div class="flex-row flex__right form-button__action margin-top-10">

          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__medium"></i>
              &nbsp;&nbsp;Đóng
            </span>
          </el-button>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>
<script>
import outgoingDocVersionService from "../../services/outgoingDocVersionService";
import h from "../../services/h";
import dateFormatter from "../../filters/dateFormatter";
import buildAttachmentURL from "../../filters/buildAttachmentURL";
import convertToLabelFilter from "../../filters/convertToLabelFilter";

export default {
  name: "vbdi-list-version-lanh-dao-edit-dialog",
  components:{
    dialogTemplate: () => import("../common/custom-dialog.vue"),
    CreateVersionLanhDaoDialog: () => import("./components/CreateVersionLanhDaoDialog.vue")
  },
  props:["title","isOpen","docId","mode", "isConfigLD"],
  filters: {dateFormatter, buildAttachmentURL, convertToLabelFilter},
  watch:{
    isOpenDialogCreateVersion(newValue) {
      newValue && (this.isEnableDialogCreateVersion = newValue);
    }
  },
  computed:{

  },
  created() {
    this.loadDocVersion();
  },
  data(){
    return{
      docVersions:[],
      docVersionActive:null,
      isOpenDialogCreateVersion: false,
      isEnableDialogCreateVersion: false
    }
  },
  methods:{
    loadDocVersion(){
      this.docVersions=[];
      outgoingDocVersionService.findAllByDocId(this.docId).then(
        res=>{
          h.each(res.data,item=>{
            this.docVersions.push({
              id: item.id,
              vbOutGoingDocId: item.vbOutGoingDocId,
              quote: item.quote,
              docTypeId: item.docTypeId,
              docDate: item.docDate,
              creatorName: item.creatorName,
              deadlineDate: item.deadlineDate,
              securityId: item.securityId,
              priorityId: item.priorityId,
              numberOfPage: item.numberOfPage,
              numberOfCopy: item.numberOfCopy,
              isLawDocument: item.isLawDocument,
              attachmentId: item.vbAttachmentIds,
              otherReceivePlaces: item.otherReceivePlaces,
              publisherId: item.publisherId,
              docCode: item.docCode,
              subBookNumber: item.subBookNumber,
              steeringTypeId: item.steeringTypeId,
              createTime:item.createTime,
              version:item.version,
              isActive:item.isActive,
              vbAttachmentIds:item.vbAttachmentIds,
              vbDocReceiversIds:item.vbDocReceiversIds,
              docAttachDocumentId: item.docAttachDocumentId,
              vbDocRelationIds:item.vbDocRelationIds,
              pdfAttachDocumentId:item.pdfAttachDocumentId
            })
          })
          this.docVersions = this.docVersions.sort((a,b)=>{
            return b.version - a.version;
          })
        }
      )
    },
    createDocSuccessVersion(event) {
      this.loadDocVersion();
      this.isOpenDialogCreateVersion = false;
      this.$emit("revertVersionDocLanhDaoEdit",this.docVersionActive)
    },

    viewDocVersion(item){
      this.docVersionActive=item;
      this.isOpenDialogCreateVersion = true;
    },
    cancel() {
      this.$emit("closeDialog");
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  }
};
</script>




// WEBPACK FOOTER //
// src/views/doc-out/vbdi-list-version-lanh-dao-edit-dialog.vue